export const HISTORY_STATUS_ALL = 'ALL';
export const HISTORY_SORT_DIRECTIONS = {
  NEWEST: 'desc',
  OLDEST: 'asc',
};

const timestamp = (entry) => {
  const value = new Date(entry?.createdAt || 0).getTime();
  return Number.isFinite(value) ? value : 0;
};

export function filterAndSortHistory(
  entries = [],
  {
    status = HISTORY_STATUS_ALL,
    direction = HISTORY_SORT_DIRECTIONS.NEWEST,
  } = {},
) {
  const filtered = status === HISTORY_STATUS_ALL
    ? entries
    : entries.filter((entry) => String(entry?.status || '').toUpperCase() === status);
  const multiplier = direction === HISTORY_SORT_DIRECTIONS.OLDEST ? 1 : -1;
  return [...filtered].sort((left, right) => {
    const difference = timestamp(left) - timestamp(right);
    if (difference !== 0) return difference * multiplier;
    return String(left?.id || '').localeCompare(String(right?.id || '')) * multiplier;
  });
}

export function paginateHistory(entries = [], page = 0, rowsPerPage = 10) {
  const safeRowsPerPage = rowsPerPage > 0 ? rowsPerPage : 10;
  const safePage = page >= 0 ? page : 0;
  return entries.slice(
    safePage * safeRowsPerPage,
    safePage * safeRowsPerPage + safeRowsPerPage,
  );
}
